import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResponseDefault } from 'src/app/shared/data/response-default.interface';
import { BaseService } from 'src/app/shared/services/base.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { environment } from 'src/environments/environment';
import { IPartner } from '../data/partner';

@Injectable({
  providedIn: 'root'
})
export class PartnerService extends BaseService {
  private readonly apiUrl = `${this.urlService}${environment.microservices.company}partner`;

  constructor(private readonly http: HttpClient, protected readonly toast: ToastService) {
    super(toast);
  }

  listActive(): Observable<ResponseDefault<IPartner[]>> {
    return this.http.get<ResponseDefault<IPartner[]>>(`${this.apiUrl}/ListActive`);
  }
}
